export default __webpack_public_path__ + "static/media/arrow-right.d960f1d7.svg";